<template>
  <div class="settings-bank-accounts">
    <el-table
        max-height="600"
        :data="tableData"
        :empty-text="$t('general_noData')"
        style="width: 100%"
        @row-click="rowClick">
      <el-table-column
          label="ID"
          type="index"
          width="50">
      </el-table-column>
      <el-table-column
          prop="name"
          label="Account Name">
      </el-table-column>
      <el-table-column
          :label="$t('settings_accountThink_taxTypes_accountGroup')">
        <template slot-scope="scope">
          {{scope.row.group.name}}
        </template>
      </el-table-column>
      <el-table-column
          width="200"
          :label="$t('settings_accountThink_taxTypes_currentBalance')">
        <template slot-scope="scope">
          {{formatPrice(scope.row.bankAccount.currentBalance)}}
        </template>
      </el-table-column>
      <el-table-column
          width="200"
          :label="$t('settings_accountThink_taxTypes_openingBalance')">
        <template slot-scope="scope">
          {{formatPrice(scope.row.bankAccount.openingBalance)}}
        </template>
      </el-table-column>
      <el-table-column
          width="100"
          :label="$t('settings_accountThink_taxTypes_currency')">
        <template slot-scope="scope">
          {{scope.row.currencyName}}
        </template>
      </el-table-column>
      <el-table-column
          :label="$t('settings_accountThink_taxTypes_createDate')"
          width="150">
        <template slot-scope="scope">
          {{moment(scope.row.createdDate).format('D MMM YY') }}
        </template>
      </el-table-column>
      <el-table-column
          width="120"
          column-key="operations"
          :label="$t('settings_accountThink_taxTypes_operations')">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"></el-button>
          <el-button
              size="mini"
              type="danger"
              plain
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <edit-bank-account-modal
        ref="editBankAccountModal"
        @loadList="loadList"/>
    <settings-bank-account-info-modal
        ref="settingBankAccountInfoModal"/>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
import EditBankAccountModal from "./EditBankAccountModal";
import SettingsBankAccountInfoModal from "./settingsBankAccountInfoModal";

export default {
  name: "settingsBankAccounts",
  components: {SettingsBankAccountInfoModal, EditBankAccountModal},
  data(){
    return {
      tableData: [],
      moment: moment
    }
  },
  methods: {
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/account/accountOnlyBank?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleEdit(index, row) {
      this.$refs.editBankAccountModal.openModal(row)
    },
    handleDelete(index, row) {
      console.log(index, row)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    rowClick(row, column, event) {
      if (column.columnKey !== 'operations') {
        this.$refs.settingBankAccountInfoModal.openModal(row)
      }
    }
  }
}
</script>

<style scoped>
  /deep/.el-table__row {
    cursor: pointer;
  }
</style>
